import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AccountResponse} from "../../../../../shared/model/response/account-response.model";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AccountService} from "../../../../../service/api/account.service";
import {MessageToastService} from "../../../../../service/message-toast.service";
import {finalize, take} from "rxjs";
import {ApiResponse} from "../../../../../shared/model/response/ApiResponse";
import {ErrorMessageEnum} from "../../../../../shared/enums/error-message.enum";
import {userBlockDurations} from "../../../../../shared/types/custom-types";
import {UserBlockRequest} from "../../../../../shared/model/request/user-block.model";

@Component({
    selector: 'app-admin-user-block-modal',
    templateUrl: './admin-user-block-modal.component.html',
    styleUrls: ['./admin-user-block-modal.component.css'],
    standalone: false
})
export class AdminUserBlockModalComponent {
  @Input('user') user: AccountResponse
  @Input('display') displayModal: boolean

  @Output('onSuccess') onSuccess = new EventEmitter<AccountResponse>()
  @Output('onCancelModal') onCancelModal = new EventEmitter<any>()

  form: FormGroup
  isLoading = false;

  formErrors: Map<string, string> = new Map<string, string>()

  durations = userBlockDurations()

  constructor(
    private accountService: AccountService,
    private messageToast: MessageToastService) {
  }

  ngOnInit(): void {

    this.form = new FormGroup({
      "duration": new FormControl(null, Validators.required),
      "motive": new FormControl(null, Validators.required),
    });
  }

  onSubmit() {
    if (this.form.invalid) this.validateFormErrors()
    else this.apiBlockAccount()
  }

  apiBlockAccount() {

    this.isLoading = true
    this.formErrors = new Map()

    let requestBody = {userId: this.user.id, ...this.form.value}

    this.accountService.blockAccount(requestBody)
      .pipe(take(1), finalize(() => this.isLoading = false))
      .subscribe({
        next: value => {
          this.messageToast.success(value.message)
          this.onSuccess.emit(value.data)
          this.onCancelModal.emit()
        },
        error: (err: ApiResponse<UserBlockRequest>) => {
          this.messageToast.error(err?.message)

          if (err.formErrors) {
            this.formErrors = err.formErrors
          }
        }
      })
  }

  validateFormErrors() {
    if (this.form.invalid) {

      if (this.form.get("motive")?.hasError("required")) {
        this.formErrors['motive'] = ErrorMessageEnum.requiredField
      }

      if (this.form.get("duration")?.hasError("required")) {
        this.formErrors['duration'] = ErrorMessageEnum.requiredField
      }
    }
  }
}
